import * as React from 'react';

export type SelectedItemsListProps = {
    title: string;
    items: ReadonlyArray<Record<'id' | 'title', string>>;
};

export const SelectedItemsList: React.FunctionComponent<SelectedItemsListProps> = ({ items, title }) => (
        <div style={{ float: 'left', paddingLeft: 15, paddingTop: 8 }}>
            <div style={{ maxHeight: '200px', maxWidth: '250px', overflowY: 'auto' }}>
                <div className="branded-alternate">
                    <h3 style={{ fontSize: 18 }}>{`${title} (${items.length})`}</h3>
                </div>
                <ul style={{ listStyleType: 'disc' }}>
                    {items.map(item => (
                        <li key={item.id}>{item.title}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
SelectedItemsList.displayName = 'SelectedItemsList';
